import { useState, useEffect } from 'react';

// 開発環境用の簡易認証フロー
export const useDevAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [shop, setShop] = useState<string>('');

  useEffect(() => {
    // URLパラメータからshopを取得
    const urlParams = new URLSearchParams(window.location.search);
    const shopParam = urlParams.get('shop');
    
    if (shopParam) {
      setShop(shopParam);
      setIsAuthenticated(true);
    }
  }, []);

  const login = (shopName: string) => {
    // 開発環境では直接認証状態を設定
    setShop(shopName);
    setIsAuthenticated(true);
    
    // URLを更新
    const newUrl = `${window.location.origin}${window.location.pathname}?shop=${shopName}`;
    window.history.replaceState({}, '', newUrl);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setShop('');
    window.location.href = '/';
  };

  return {
    isAuthenticated,
    shop,
    login,
    logout
  };
};
